import { TimeInForce } from "@/generated/TradingGateway"

export interface SelectItem {
  label: string
  value: string
}

export const timeInForceSelections: SelectItem[] = [
  { label: "Day", value: TimeInForce.Day },
  { label: "Good-Til-Canceled", value: TimeInForce.Gtc },
  { label: "Submit On Market Open", value: TimeInForce.Opg },
  { label: "Submit On Market Close", value: TimeInForce.Cls },
  { label: "Immediate-Or-Cancel", value: TimeInForce.Ioc },
  { label: "Fill-Or-Kill", value: TimeInForce.Fok },
]
